import _ from "lodash";
import React from "react";
import classNames from "classnames";

import { Checkbox, Tooltip } from "@toddle-edu/ds-web";
import ConditionalWrapper from "Utils/ConditionalWrapper";

import { useI18n } from "Hooks";
import ProfileCascade from "UIComponents/ProfileCascade";

import { STAFF, STUDENT, PARENT } from "Constants/stringConstants";

import { useMetadata } from "AppComponents/DualPanelManageMembersV2/components/MetadataProvider";

import classes from "./CohortSelectionCard.scss";

const avatarStyles = {
  size: "medium",
  shade: "light",
  randomizeColor: true,
  shape: "square",
};

const CohortSelectionCard = props => {
  const {
    userList = [],
    title,
    id,
    cohortType,
    onAddCohort,
    onRemoveCohort,
    isChecked,
    isIndeterminate,
    type,
    testId,
    subTextComponent,
  } = props;

  const { t } = useI18n(["common"]);
  const { getEmptyCohortsTooltip } = useMetadata();
  const componentTestId = testId ? testId : undefined;
  const userCount = _.size(userList);
  const isDisabled = userCount === 0;

  const mapSubtitleTextToUserType = {
    [STUDENT]: t("common:student_count", { count: userCount }),
    [STAFF]: t("common:staff_members_count_lowercase", { count: userCount }),
    [PARENT]: t("common:family_member_count", { count: userCount }),
  };

  const userSubTitleText = mapSubtitleTextToUserType[type];

  const handleCohortClick = () => {
    if (isDisabled) return;
    const cohortId = `${id}-${type}`;
    if (isChecked || isIndeterminate) {
      onRemoveCohort({ cohortType, cohortId });
    } else {
      onAddCohort({ users: userList, cohortType, cohortId });
    }
  };

  const cohortTitleClasses = classNames(classes.userTitle, "text-body");
  const cohortSubTitleClasses = classNames(classes.userSubTitle, "text-body-s");

  return (
    <div className={classes.selectionCardContainer}>
      <div className={classes.userAvatar}>
        <ProfileCascade
          dsVersion="2.0"
          items={[
            {
              id,
              value: title,
            },
          ]}
          shouldDynamicColor
          showAvatar
          avatarStyles={avatarStyles}
        />
      </div>
      <div className={classes.userInfoContainer}>
        <div className={cohortTitleClasses}>{title}</div>
        {subTextComponent ? (
          subTextComponent
        ) : (
          <div className={cohortSubTitleClasses}>{userSubTitleText}</div>
        )}
      </div>
      <div className={classes.checkboxContainer}>
        <ConditionalWrapper
          condition={isDisabled}
          wrapper={
            <Tooltip
              placement="top"
              tooltip={getEmptyCohortsTooltip({ cohortType, t })}
            />
          }
          type={"wrapperAsElement"}
        >
          <Checkbox
            onChange={handleCohortClick}
            isChecked={isChecked}
            isIndeterminate={isIndeterminate}
            disabled={isDisabled}
            testId={componentTestId}
          />
        </ConditionalWrapper>
      </div>
    </div>
  );
};

export default CohortSelectionCard;
